// internal

// owned
import Log4jsProvider from './log4js-provider.js'

// module vars
const log4jsProvider = new Log4jsProvider()
export default log4jsProvider
